import angular from 'angular';

import Component from './experience-flyout.component';

const Module = angular
    .module('control-room.commons.basic.components.experience-flyout', [])
    .component('crExperienceFlyout', Component);

export default Module;
